// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"107":"76d8c668","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"107":"8064e22757a395885c32","678":"f0a55146fd2b41b7e65a","883":"873b143729d4c6751492"}[chunkId] + ".js";
};